import React from 'react'
import _ from 'lodash'

import {Row, Col, Alert} from 'react-flexbox-grid'

import {Button, Tooltip} from 'antd'

import {DeviceService} from 'api/device'

import {SetupGuide} from './'
import {Form, Input, Submit} from 'forms'
import {AddressEncoder, Loading} from 'ui'
import {parse as decodeAddress} from 'util/address.js'

export class CreateGateway extends React.Component {
   static get propTypes() {
      return {
         location: React.PropTypes.object.isRequired,
         routes:   React.PropTypes.array.isRequired,
         router:   React.PropTypes.object.isRequired,
         network:  React.PropTypes.object.isRequired
      }
   }

   constructor() {
      super()
      this.state = {
         creatingGateway: false,
         error:           false
      }

      this.skipSetup = this.skipSetup.bind(this)
      this.handleSubmit = this.handleSubmit.bind(this)
   }

   componentWillMount() {
      const {network} = this.props

      if ('true' !== this.props.location.query.autoCreate) {
         return
      }

      // if any custom work has been done, consider ourselves done
      if (0 !== network.devices.length && 2 !== network.channels.length) {
         return
      }

      this.setState({creatingGateway: true, error: false})

      const payload = {name: 'Gateway #1', address: 0, type: 'gateway'}

      DeviceService.create(network.key, payload)
         .catch(() => this.setState({creatingGateway: false, error: true}))
         .done(() => this.setState({creatingGateway: false}))
   }

   handleSubmit(ev, patch) {
      const {network} = this.props

      ev.preventDefault()

      this.setState({creatingGateway: true, error: false})

      return DeviceService.create(network.key, patch)
         .then(resp => {
            this.setState({creatingGateway: false})

            return resp
         })
         .catch(_err => this.setState({creatingGateway: false}))
   }

   skipSetup() {
      let {router, routes} = this.props,
         newRoutes = _.slice(routes, 0, -1),
         nextPath = _.map(newRoutes, r => r.path)
            .slice(0, -1)
            .concat(['network', this.props.network.key, 'overview'])
            .join('/')
            .replace('//', '/')

      SetupGuide.skipSetup(this.props.network)

      router.push(nextPath)
   }

   get Form() {
      return () => (
         <div>
            <div className="page-header">
               <h4>Create Gateway</h4>
            </div>

            {this.state.error &&
               false === this.state.creatingGateway &&
               <Alert bsStyle="danger">
                  <b>An unexpected error occured</b><br />
                  There was an error creating your Gateway, try creating it manually.
               </Alert>}

            <Form
               defaultValues={{address: '::0', type: 'gateway'}}
               transform={({address, ...rest}) => _.set(rest, 'address', decodeAddress(address))}
               onSubmit={this.handleSubmit}
            >

               <Form.Updated>Network was successfully updated</Form.Updated>
               <Form.Error>Some error occurred during submit</Form.Error>

               <Input param="name" label="Gateway Name" />
               <Input
                  param="address"
                  label="Unique ID"
                  groupCssClass="feedback-inline"
                  validate={n => {
                     if (!_.isNumber(decodeAddress(n)) || isNaN(decodeAddress(n))) {
                        return {error: 'Invalid address'}
                     }

                     return true
                  }}
                  feedback={({value, error}) => {
                     let parsedValue = decodeAddress(value || '0')

                     return (
                        <span className="help-block">
                           {error
                              ? error
                              : <AddressEncoder pretty={true} value={decodeAddress(parsedValue)} />}
                        </span>
                     )
                  }}
               />

               <div className="text-right" style={{clear: 'both'}}>
                  <Submit icon="check">Create Gateway</Submit>
                  &nbsp;
                  <Button icon="close" onClick={this.skipSetup}>
                     Skip guide
                  </Button>
               </div>
            </Form>
         </div>
      )
   }

   render() {
      const {creatingGateway, error} = this.state,
         InnerForm = this.Form,
         UIDText = 'All Tinymesh devices have a Unique ID',
         NIDText = 'Gateways can be configured with a Network ID used for identification'

      return (
         <Loading loading={creatingGateway} overlay={true}>
            <Row style={{marginTop: '3rem', position: 'relative'}}>
               <Col md={6}>
                  <InnerForm error={error} />
               </Col>

               <Col md={6}>
                  <p style={{marginTop: '3em', marginBottom: '2rem'}}>
                     Tinymesh Networks communicates through one or more Gateway Devices.
                     The gateway we define represents one Tinymesh gateway, the
                     Unique ID you enter here must correspond to the Unique ID
                     of your Tinymesh Gateway.
                  </p>

                  <p>
                     The gateway authenticates by using a combination of&nbsp;
                     <Tooltip title={UIDText}><a>Unique ID (UID)</a></Tooltip>
                     {' '}
                     and&nbsp;
                     <Tooltip title={NIDText}><a>Network ID (NID)</a></Tooltip>,
                     you can use `<code>0</code>` as UID if you are
                     unsure about your gateways UID.
                  </p>
               </Col>
            </Row>
         </Loading>
      )
   }
}



// WEBPACK FOOTER //
// lib/bundle/dashboard/setup-guide/CreateGateway.jsx